import { Box, Paper } from "@mui/material";
import type { FC } from "react";
import type { UUID } from "../../../../../../../utils/uuid";
import { FOOTER_HEIGHT } from "../../../../../../generic/components/fixed-footer";
import { PreviewAlert } from "./preview-alert";
import { PreviewBodyContent } from "./preview-body-content";
import { PreviewBodyHead } from "./preview-body-head";

export const PreviewBody: FC<{
  momentId: UUID;
  isNewsletter?: boolean;
  sendTestButton?: React.ReactNode;
  toggles?: React.ReactNode;
  /** Fill the container instead of reserving room for the fixed footer, when the container
   * already stops above it. */
  fullHeight?: boolean;
}> = ({ momentId, isNewsletter, sendTestButton, toggles, fullHeight }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        flexGrow: 1,
        overflow: "auto", // Allows scrolling in the main content area
        height: fullHeight ? "100%" : `calc(100% - ${FOOTER_HEIGHT})`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PreviewAlert sendTestButton={sendTestButton} />
      <PreviewBodyHead isNewsletter={isNewsletter ?? false} toggles={toggles} />
      <Box
        sx={{
          bgcolor: "background.paper",
          flexGrow: 1, // This will make the Box take up all remaining space
          minHeight: 0, // ...and lets it shrink, rather than forcing the Paper to scroll
        }}
      >
        <PreviewBodyContent momentId={momentId} isNewsletter={isNewsletter ?? false} />
      </Box>
    </Paper>
  );
};
